import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  {
    path: 'landing',
    loadComponent: () =>
      import('./components/landing/landing.component').then(
        (mod) => mod.LandingComponent,
      ),
  },

  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login.component').then(
        (mod) => mod.LoginComponent,
      ),
  },

  {
    path: 'register/new-member',
    loadComponent: () =>
      import('./components/register/new-member/new-member.component').then(
        (mod) => mod.NewMemberComponent,
      ),
  },

  {
    path: 'register/new-company',
    loadComponent: () =>
      import('./components/register/company-registration/company-registration.component').then(
        (mod) => mod.CompanyRegistrationComponent,
      ),
  },

  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/dashboard/dashboard.component').then(
        (mod) => mod.DashboardComponent,
      ),
    children: [
      { path: '', redirectTo: 'stats', pathMatch: 'full' },
      {
        path: 'stats',
        loadComponent: () =>
          import('./components/dashboard/stats/stats.component').then(
            (mod) => mod.StatsComponent,
          ),
      },

      {
        path: 'estatement',
        loadComponent: () =>
          import('./components/dashboard/estatement/estatement.component').then(
            (mod) => mod.EstatementComponent,
          ),
      },

      {
        path: 'smartlife',
        loadComponent: () =>
          import('./components/dashboard/smartlife/accounts/accounts.component').then(
            (mod) => mod.AccountsComponent,
          ),
      },
      {
        path: 'smartlife/view-account',
        loadComponent: () =>
          import('./components/dashboard/smartlife/accounts/view-account/view-account.component').then(
            (mod) => mod.ViewAccountComponent,
          ),
      },
      {
        path: 'smartlife/view-account-detials',
        loadComponent: () =>
          import('./components/dashboard/smartlife/account-details/account-details.component').then(
            (mod) => mod.AccountDetailsComponent,
          ),
      },

      {
        path: 'smartlife-fixed',
        loadComponent: () =>
          import('./components/dashboard/smartlife/fixed/fixed.component').then(
            (mod) => mod.FixedComponent,
          ),
      },
      {
        path: 'smartlife-group',
        loadComponent: () =>
          import('./components/dashboard/smartlife/group/group.component').then(
            (mod) => mod.GroupComponent,
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./components/dashboard/profile/profile.component').then(
            (mod) => mod.ProfileComponent,
          ),
      },
      {
        path: 'additional-details',
        loadComponent: () =>
          import('./components/dashboard/profile/additional-details/additional-details.component').then(
            (mod) => mod.AdditionalDetailsComponent,
          ),
      },

      {
        path: 'salary-analysis',
        loadComponent: () =>
          import('./components/dashboard/salary-analysis/salary-analysis.component').then(
            (mod) => mod.SalaryAnalysisComponent,
          ),
      },

      {
        path: 'contributions',
        loadComponent: () =>
          import('./components/dashboard/contributions/contributions.component').then(
            (mod) => mod.ContributionsComponent,
          ),
      },

      {
        path: 'benefits',
        loadComponent: () =>
          import('./components/dashboard/benefits/benefits.component').then(
            (mod) => mod.BenefitsComponent,
          ),
      },

      {
        path: 'benefits-tracking',
        loadComponent: () =>
          import('./components/dashboard/benefits/benefits-tracking/benefits-tracking.component').then(
            (mod) => mod.BenefitsTrackingComponent,
          ),
      },

      {
        path: 'Calculators',
        loadComponent: () =>
          import('./components/dashboard/calculators/calculators.component').then(
            (mod) => mod.CalculatorsComponent,
          ),
      },
      {
        path: 'smartlife-fixed/view-account',
        loadComponent: () =>
          import('./components/dashboard/smartlife/fixed/fixed-account-detail/fixed-account-detail.component').then(
            (mod) => mod.FixedAccountDetailComponent,
          ),
      },
    ],
  },

  {
    path: '**',
    loadComponent: () =>
      import('./components/not-found/not-found.component').then(
        (mod) => mod.NotFoundComponent,
      ),
  },
];
